import { render, staticRenderFns } from "./Investmentprojects.vue?vue&type=template&id=fe6fa52a&scoped=true&"
import script from "./Investmentprojects.vue?vue&type=script&lang=js&"
export * from "./Investmentprojects.vue?vue&type=script&lang=js&"
import style0 from "./Investmentprojects.vue?vue&type=style&index=0&id=fe6fa52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6fa52a",
  null
  
)

export default component.exports